if (!customElements.get('before-after-slider')) {
  class BeforeAfterSlider extends HTMLElement {
    constructor() {
      super();
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onRangeInput = this.onRangeInput.bind(this);
      this.isDragging = false;
    }

    connectedCallback() {
      this.frame = this.querySelector('.before-after__media-frame');
      this.range = this.querySelector('[data-range]');
      this.beforeImage = this.querySelector('[data-before-image]');

      if (!this.frame || !this.range || !this.beforeImage) return;

      const startPosition = Number(this.dataset.startPosition || this.range.value || 50);
      this.setPosition(startPosition);
      this.toggleHintAnimation(startPosition);

      this.range.addEventListener('input', this.onRangeInput);
      this.frame.addEventListener('pointerdown', this.onPointerDown);
      this.resizeObserver = new ResizeObserver(() => {
        this.setPosition(this.range.value);
      });
      this.resizeObserver.observe(this.frame);

      if (this.dataset.dragOnHover === 'true') {
        this.frame.addEventListener('pointermove', this.onPointerMove);
      }
    }

    disconnectedCallback() {
      if (this.range) {
        this.range.removeEventListener('input', this.onRangeInput);
      }

      if (this.frame) {
        this.frame.removeEventListener('pointerdown', this.onPointerDown);
        this.frame.removeEventListener('pointermove', this.onPointerMove);
      }

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerUp);
    }

    onRangeInput(event) {
      this.stopHintAnimation();
      this.setPosition(event.target.value);
    }

    onPointerDown(event) {
      this.isDragging = true;
      this.stopHintAnimation();
      this.updateFromPointer(event);
      window.addEventListener('pointermove', this.onPointerMove);
      window.addEventListener('pointerup', this.onPointerUp, { once: true });
    }

    onPointerMove(event) {
      if (this.dataset.dragOnHover !== 'true' && !this.isDragging) return;
      this.updateFromPointer(event);
    }

    onPointerUp() {
      this.isDragging = false;
      window.removeEventListener('pointermove', this.onPointerMove);
    }

    updateFromPointer(event) {
      if (!this.frame) return;

      const bounds = this.frame.getBoundingClientRect();
      const offset = event.clientX - bounds.left;
      const percentage = (offset / bounds.width) * 100;
      this.setPosition(percentage);
    }

    setPosition(value) {
      const nextValue = Math.min(100, Math.max(0, Number(value)));
      this.style.setProperty('--before-after-position', `${nextValue}%`);
      this.updateClipRect(nextValue);

      if (this.range) {
        this.range.value = Math.round(nextValue);
        this.range.setAttribute('aria-valuenow', Math.round(nextValue));
      }
    }

    toggleHintAnimation(position) {
      if (!this.frame) return;
      this.frame.classList.toggle('is-animated', Math.round(position) === 50);
    }

    stopHintAnimation() {
      if (!this.frame) return;
      this.frame.classList.remove('is-animated');
    }

    updateClipRect(position) {
      if (!this.frame || !this.beforeImage) return;

      const width = this.frame.clientWidth;
      const clipRight = (width * position) / 100;
      this.beforeImage.style.clip = `rect(auto, ${clipRight}px, auto, auto)`;
    }
  }

  customElements.define('before-after-slider', BeforeAfterSlider);
}
